export enum RegistryBannerVariant {
  ChecklistBreastPumpBanner,
  SearchResultBreastPumpBanner,
  SearchSuggestionBreastPumpBanner,
}
